import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import {
  QUIZ_GROUP_MIN_TERM,
  QUIZ_GROUP_MIN_USERS,
  type QuoteSegment,
} from '../constants/quizQuote.const';
import {
  type QuizQuoteFormValues,
  quizQuoteSchema,
} from '../utils/quizQuote.schema';
import { todayISO } from '../utils/quoteDate';

/** 진입 세그먼트에 맞춘 견적 폼 기본값(프리필). */
function getDefaultValues(segment: QuoteSegment): QuizQuoteFormValues {
  const isGroup = segment === 'group';

  return {
    // plan(Basic/Pro)·plan_type(개인/학교·단체) 모두 사용자 선택.
    // 진입 세그먼트로 초기값만 프리필: 단체 진입 → Pro·학교·단체·5인·3개월, 그 외 → Pro·개인.
    plan: 'pro',
    plan_type: isGroup ? 'group' : 'individual',
    school_name: '',
    account_name: '',
    account_phone: '',
    account_email: '',
    user_count: isGroup ? QUIZ_GROUP_MIN_USERS : 1,
    term: isGroup ? QUIZ_GROUP_MIN_TERM : 1,
    start_date: todayISO(),
    annotation: '',
    consent: false,
  };
}

/** 견적 폼 인스턴스 — 스키마 resolver + 세그먼트 기본값. */
export function useQuizQuoteForm(segment: QuoteSegment) {
  return useForm<QuizQuoteFormValues>({
    resolver: zodResolver(quizQuoteSchema),
    defaultValues: getDefaultValues(segment),
    mode: 'onTouched',
  });
}
